const ATTEMPT_ACTION = {
    OPEN_INSTRUCTIONS: 'OPEN_INSTRUCTIONS',
    CLOSE_INSTRUCTIONS: 'CLOSE_INSTRUCTIONS',
    SET_DATA: 'SET_DATA',
    RESET_STORE: 'RESET_STORE',
    UPDATE_REM_TIME: 'UPDATE_REM_TIME',
    SET_ACTIVE_QUESTION: 'SET_ACTIVE_QUESTION',
    SET_ATTEMPT_EDITOR_FULL_SCREEN: 'SET_ATTEMPT_EDITOR_FULL_SCREEN',
    START_ATTEMPT: 'START_ATTEMPT',
    SET_ATTEMPT_STATE: 'SET_ATTEMPT_STATE',
    DECREMENT_REM_TIME: 'DECREMENT_REM_TIME',
    SET_ANSWER: 'SET_ANSWER',
    OPEN_QUESTION_PALETTE: 'OPEN_QUESTION_PALETTE',
    CLOSE_QUESTION_PALETTE: 'CLOSE_QUESTION_PALETTE',
    MARK_QUESTION_FOR_REVIEW: 'MARK_QUESTION_FOR_REVIEW',
    UNMARK_QUESTION_FOR_REVIEW: 'UNMARK_QUESTION_FOR_REVIEW',
    SUBMIT_ATTEMPT: 'SUBMIT_ATTEMPT',
    AUTOSAVE_ATTEMPT: 'AUTOSAVE_ATTEMPT',
    SAVE_DATA: 'SAVE_DATA',
    DATA_SAVED: 'DATA_SAVED',
    UPDATE_LOCAL_USER_SOLUTION_DATA: 'UPDATE_LOCAL_USER_SOLUTION_DATA',
    SAVE_INTEGRITY_CHECK_DATA: 'SAVE_INTEGRITY_CHECK_DATA',
    SET_PMF_MODE: 'SET_PMF_MODE',
    MARK_QUESTION_UNSAVED: 'MARK_QUESTION_UNSAVED',
    SET_REMAINING_LIVES: 'SET_REMAINING_LIVES',
    SET_AUTO_CLOSE: 'SET_AUTO_CLOSE',
    SET_BANNER_STATUS: 'SET_BANNER_STATUS',
}

export default ATTEMPT_ACTION
